import React from 'react';
import { observer } from 'mobx-react';
import { ClinicalStatusListTemplate } from 'themes/application/clinical-status/pages';
import { setCurrentView } from 'core/utils';
import { ClinicalStatusListViewStore } from 'application/clinical-status/stores';

@setCurrentView((rootStore) => new ClinicalStatusListViewStore(rootStore), 'clinicalStatusListViewStore')
@observer
class ClinicalStatusList extends React.Component {
    render() {
        return <ClinicalStatusListTemplate {...this.props} />
    }
}

export default ClinicalStatusList;